import React from 'react';

class FileAttachment extends React.PureComponent {
  constructor(props) {
    super(props);

    this.fileInput = React.createRef();

    this.state = {
      file: null,
    };

    this.onSelectFile = this.onSelectFile.bind(this);
  }

  onSelectFile(e) {
    try {
      const [file] = e.nativeEvent.target.files;
      this.setState(() => ({ ...this.state, file }));

      if (this.props.onChange) {
        this.props.onChange(file);
      }

    } catch (err) {}
  }

  render() {
    return (
      <React.Fragment>
        <button
          type="button"
          className="button button--light"
          onClick={() => {
            if (this.fileInput.current) {
              this.fileInput.current.click();
            }
          }}
        >
          {this.state.file !== null
            ? this.state.file.name
            : this.props.children
          }
        </button>
        <input
          required={this.props.required}
          name={this.props.name}
          ref={this.fileInput}
          type="file"
          accept={this.props.mimeTypes}
          style={{width: 0, height: 0}}
          onChange={this.onSelectFile}
        />
      </React.Fragment>
    )
  }
}

export default FileAttachment;
